import classname from 'classname';
import { Playicon, SearchTableIcon } from 'components/icons';
import DashboardLayout from 'layout/dashboardLayout';
import React, { useCallback, useEffect, useState } from 'react';
import { globalStyles } from 'styles';
import styles from './guides.module.scss';
import VideoModal from './VideoModal';
import { fetchGuides } from 'store/actions/guides';
import { useDispatch, useSelector } from 'react-redux';
import Fetching from 'components/Fetching';
import EmptyState from 'components/EmptyState';
import Pagination from 'components/common/pagination';
import { getVideoId } from 'libs';
import debounce from 'lodash.debounce';

export default function Guides() {
  const [showModal, setShowModal] = useState(false);
  const [playUrl, setPlauUrl] = useState('');
  const [currentPage, setCurrentPage] = React.useState(1);
  const [query, setQuery] = React.useState('');
  const dispatch = useDispatch();

  const debouncedGuides = useCallback(
    debounce(
      (query) =>
        getGuides({
          type: 'VIDEO',
          status: 'ACTIVE',
          searchTerm: query,
        }),
      800,
    ),
    [],
  );

  const getGuides = React.useCallback(
    (params) => dispatch(fetchGuides(params)),
    [dispatch],
  );

  const handleChange = (e) => {
    const value = e.target.value;
    setQuery(value);
    debouncedGuides(value);
  };

  const { inProgress, guides, pagination } = useSelector(
    (state) => state.guides,
  );

  useEffect(() => {
    getGuides({
      type: 'VIDEO',
      status: 'ACTIVE',
    });
  }, []);

  const handleVideoClick = (url) => {
    setPlauUrl(url);
    setShowModal(true);
  };

  const handlePageClick = (data) => {
    setCurrentPage(data.selected + 1);
    getGuides({
      type: 'VIDEO',
      status: 'ACTIVE',
      ...pagination,
      page: data.selected + 1,
    });
  };

  return (
    <DashboardLayout>
      <>
        <div className={styles.guideContainerBody}>
          <VideoModal
            handleClose={() => setShowModal(false)}
            showModal={showModal}
            url={playUrl}
          />
          <div className={globalStyles.tablesearchcontainer}>
            <SearchTableIcon className={globalStyles.tablesearchicon} />
            <input
              type="text"
              placeholder="Search by any field"
              value={query}
              onChange={(e) => handleChange(e)}
              className={classname(globalStyles.tablesearch)}
            />
          </div>
          {inProgress ? (
            <Fetching height="70vh" />
          ) : (
            <div className={styles.guideContainer}>
              <div className={styles.guides}>
                {guides.map(({ id, title, url }) => (
                  <div className={styles.guide} key={id}>
                    <button
                      className={styles.play}
                      onClick={() => handleVideoClick(url)}
                    >
                      <Playicon />
                    </button>
                    <div className={styles.videoBody}>
                      <img
                        src={`https://img.youtube.com/vi/${getVideoId(
                          url,
                        )}/maxresdefault.jpg`}
                        className={styles.img}
                      ></img>
                      <p>{title}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </>

      {!inProgress && guides.length == 0 ? (
        <div className={styles.empty}>
          <EmptyState text="You will see guides here when they are available" />
        </div>
      ) : null}

      {!inProgress && (
        <div data-testid="pagination" className={styles.pagination}>
          <Pagination
            currentPage={currentPage}
            handlePageClick={handlePageClick}
            totalItems={Math.ceil(pagination.total / pagination.limit)}
          />
        </div>
      )}
    </DashboardLayout>
  );
}
